import React from 'react'
import { Drawer, Form } from 'rsuite'
import Icon from './Icon'

/**
 * Panel that slides in from the right with a form of options
 * @param {Object} props component props
 * @param {boolean} props.show whether the panel is open
 * @param {Function} props.onClose called when the panel is closed
 * @param {string} props.icon icon before the title, none when empty
 * @param {string} props.title title of the panel
 * @param {*} props.children form groups of the panel
 * @returns {JSX.Element} drawer
 */
const SideDrawer = ( { show = false, onClose, icon = '', title = '', children } ) =>
{
  /**
   * Fix the double intro animation
   * @param {HTMLElement} e drawer element
   * @returns {void}
   */
  const onEntered = ( e ) =>
  {
    e.classList.remove( 'slide-in', 'animated' )
  }

  return (
    <Drawer open={ show } onClose={ onClose } className="options-drawer" onEntered={ onEntered }>
      <Drawer.Header>
        <Drawer.Title>{ icon && <Icon icon={ icon }/> } { title }</Drawer.Title>
      </Drawer.Header>
      <Drawer.Body>
        <Form className="options-form">
          { children }
        </Form>
      </Drawer.Body>
    </Drawer>
  )
}

export default SideDrawer
